







































import CFMDialog from '@/scripts/CFMDialog'
import { Component, Vue } from 'vue-property-decorator';

import * as blockui from '@/helpers/block-ui'

import {required} from "vuelidate/lib/validators";

import { CFMDTOTrainingType } from '@/scripts/services/ClientApiAuto'

@Component<TrainingTypeDialog>({
    validations() {
        return {
          trainingType:{
              Name: {required},
          },
        }
    },
})
export default class TrainingTypeDialog extends CFMDialog {
    trainingType: CFMDTOTrainingType = {Name: ''};

    async created(){
      blockui.blockModal(this);
      if(this.isUpdate){
        const res = await this.apiClient.trainingType.trainingTypeGetById({id: <number>this.id});
        this.trainingType = res.data;
      }
      blockui.unBlockModal();
    }

    get isUpdate() {
        return !!this.id;
    }

    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
          return;
      }
      
      let formData:CFMDTOTrainingType = {
        Id: this.trainingType.Id,
        Name: this.trainingType.Name,
      };

      blockui.blockModal(this);
      try{
        const response  = await this.apiClient.trainingType.trainingTypeSave(formData);
        if (response.data.IsSuccess) {
          toastr.success(this.translate('save_successfully'));
          this.saveSucceeded();
          this.close();
        } else {
          const errorMessage = response.data.Message ? response.data.Message : "Error";
          toastr.error(errorMessage);
        }
      }
      catch(e){
        console.log("err",e)
        toastr.error(e);
      }
      finally{
        blockui.unBlockModal();
      }
    }
}
